var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fluid att-card" }, [
    _c(
      "div",
      { staticClass: "card-body py-0 px-0 fluid" },
      [
        _c(
          "b-row",
          {
            staticClass: "att-header px-4 w-100",
            attrs: { "no-gutters": "", "align-v": "center" },
          },
          [
            _c("b-col", { staticClass: "capitalize att-title" }, [
              _vm._v("\n        " + _vm._s(_vm.attributesName) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "b-col",
              {
                staticClass: "d-flex align-items-center justify-content-end",
                attrs: { cols: "3" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "header-icon-btn",
                    attrs: {
                      id: "minOrMaxAttributeElement",
                      type: "button",
                      title: _vm.attributesMinimized
                        ? "Maximize Attributes"
                        : "Minimize Attributes",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$emit(
                          _vm.attributesMinimized
                            ? "maximizeAttributes"
                            : "minimizeAttributes"
                        )
                      },
                    },
                  },
                  [
                    _c("fa", {
                      attrs: {
                        icon: [
                          "fas",
                          _vm.attributesMinimized
                            ? "window-maximize"
                            : "window-minimize",
                        ],
                      },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.attributesMinimized,
                expression: "!attributesMinimized",
              },
            ],
            staticClass: "att-body",
          },
          _vm._l(_vm.attribResponse, function (resp, index) {
            return _c(
              "b-row",
              {
                key: index,
                staticClass: "att-row w-100",
                attrs: { "no-gutters": "", "align-v": "center" },
              },
              [
                _c(
                  "b-col",
                  { staticClass: "att-text att-name", attrs: { cols: "6" } },
                  [_vm._v(_vm._s(resp.name))]
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  {
                    staticClass: "att-value",
                    attrs: {
                      id: "editor" + index,
                      cols: "6",
                      title: "Copy Value",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.copyText(resp.value)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          resp.name == "created_date" ||
                            resp.name == "updated_date"
                            ? resp.value
                              ? resp.value.replace("Z", "")
                              : resp.value
                            : resp.value
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            )
          }),
          1
        ),
        _vm._v(" "),
        _c(
          "b-row",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.attributesMinimized,
                expression: "!attributesMinimized",
              },
            ],
            staticClass: "att-footer w-100",
            attrs: { "no-gutters": "", "align-v": "center" },
          },
          [
            _c(
              "b-col",
              {
                staticClass: "d-flex flex-row align-items-center g-2",
                attrs: { cols: "6" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "pager-btn",
                    attrs: { type: "button", disabled: _vm.feature_index < 1 },
                    on: {
                      click: function ($event) {
                        return _vm.getNextFeature(-1)
                      },
                    },
                  },
                  [_c("fa", { attrs: { icon: ["fas", "chevron-left"] } })],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "pager-count" }, [
                  _vm._v(
                    _vm._s(_vm.feature_index + 1) +
                      " of " +
                      _vm._s(_vm.features.length)
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "pager-btn",
                    attrs: {
                      type: "button",
                      disabled: _vm.feature_index + 1 >= _vm.features.length,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.getNextFeature(1)
                      },
                    },
                  },
                  [_c("fa", { attrs: { icon: ["fas", "chevron-right"] } })],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "b-col",
              {
                staticClass: "d-flex justify-content-end align-items-center",
                attrs: { cols: "6" },
              },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "close-btn px-4 py-2",
                    on: {
                      click: function ($event) {
                        return _vm.closeAttTable()
                      },
                    },
                  },
                  [_vm._v("Close")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }